// extracted by mini-css-extract-plugin
export default {"button":"CheckoutButton--button--db8930"};